<div class="display-flex full-width full-height ag-grid-no-rows">
  <div [innerHTML]="this.params.noRowsMessage | translate"></div>
</div>
